import Layout from '@/layout'

export default [
  {
    path: '/',
    name: 'Home',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'Index',
        component: () => import(/*webpackChunkName:'Index'*/ '@/views/home'),
        meta: { title: '首页', homePage: true },
      },
    ],
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import(/*webpackChunkName:'Search'*/ '@/views/search'),
    meta: { title: '搜索' },
  },
  {
    path: '/search/result',
    name: 'SearchResult',
    component: () => import(/*webpackChunkName:'SearchResult'*/ '@/views/search/SearchResult'),
    meta: { title: '搜索结果' },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/*webpackChunkName:'Login'*/ '@/views/login/index'),
    meta: { title: '登录' },
  },
  {
    path: '/phoneLogin',
    name: 'PhoneLogin',
    component: () => import(/*webpackChunkName:'PhoneLogin'*/ '@/views/login/PhoneLogin'),
    meta: { title: '手机登录' },
  },
  {
    path: '/bindEmail',
    name: 'BindEmail',
    component: () => import(/*webpackChunkName:'BindEmail'*/ '@/views/login/BindEmail'),
    meta: { title: '绑定邮箱' },
  },
  {
    path: '/bindSuccess',
    name: 'BindSuccess',
    component: () => import(/*webpackChunkName:'BindSuccess'*/ '@/views/login/BindSuccess'),
    meta: { title: '绑定成功' },
  },
  {
    path: '/changePass',
    name: 'ChangePass',
    component: () => import(/*webpackChunkName:'ChangePass'*/ '@/views/login/ChangePass'),
    meta: { title: '修改密码' },
  },
  {
    path: '/changePhone',
    name: 'ChangePhone',
    component: () => import(/*webpackChunkName:'ChangePhone'*/ '@/views/login/ChangePhone'),
    meta: { title: '更换手机' },
  },
  {
    path: '/changeName',
    name: 'ChangeName',
    component: () => import(/*webpackChunkName:'ChangeName'*/ '@/views/login/ChangeName'),
    meta: { title: '修改昵称' },
  },
  {
    path: '/changeSuccess',
    name: 'ChangeSuccess',
    component: () => import(/*webpackChunkName:'ChangeSuccess'*/ '@/views/login/ChangeSuccess'),
    meta: { title: '修改成功' },
  },
  {
    path: '/buildQRcode',
    name: 'BuildQRcode',
    component: () => import(/*webpackChunkName:'BuildQRcode'*/ '@/views/buildQRcode/index'),
    meta: { title: '启航计划分销二维码生成器' },
  },
  {
    path: '/buildQRcode/success',
    name: 'BuildQRcodeSuccess',
    component: () =>
      import(/*webpackChunkName:'BuildQRcodeSuccess'*/ '@/views/buildQRcode/success'),
    meta: { title: '启航计划分销二维码生成器' },
  },
  {
    path: '/sailingPlan',
    name: 'SailingPlan',
    component: () => import(/*webpackChunkName:'SailingPlan'*/ '@/views/sailingPlan/index'),
    meta: { title: '启航计划' },
  },
  {
    path: '/sailingPlan/success',
    name: 'SailingPlanSuccess',
    component: () =>
      import(/*webpackChunkName:'SailingPlanSuccess'*/ '@/views/sailingPlan/success'),
    meta: { title: '报名成功' },
  },
  {
    path: '/leader/hospital',
    name: 'Hospital',
    component: () => import(/*webpackChunkName:'SailingPlanSuccess'*/ '@/views/hospital/index'),
    meta: { title: '集团公司总部体检管理' },
  },
  // {
  //   path: '/redirect',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/redirect/:path*',
  //       component: () => import(/*webpackChunkName:'Redirect'*/ '@/views/redirect'),
  //     },
  //   ],
  // },
  // {
  //   path: '/exception',
  //   name: 'ErrorPage',
  //   component: Layout,
  //   type: 'system',
  //   children: [
  //     {
  //       path: '404',
  //       name: '404',
  //       component: () => import(/* webpackChunkName: '404' */ '@/views/error/404.vue'),
  //       hidden: true,
  //       meta: { title: '404' },
  //     },
  //   ],
  // },
  // {
  //   path: '*',
  //   name: '*404',
  //   redirect: '/exception/404',
  //   hidden: true,
  // },
]
